import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import browserHistory from 'helpers/history'

import confirmTypes from 'helpers/enums/confirmTypes'
import generalActions from 'redux/actions/generalActions'
import config from 'config'
import redirectTo from 'helpers/redirection'
import { localize } from 'helpers/translator'

const CONFIRM_TYPE = confirmTypes.USER_NOT_LOGGED_IN_CONFIRM

const UserIsLoggedInConfirm = props => (<Confirm
	btOne={localize('global_signUp')}
	btTwo={localize('global_logIn')}
	alertTitle={localize('user_loggedIn_confirm_title')}
	alertMessage={localize('user_loggedIn_confirm_message')}
	actionButtonType={0}
	actionOne={
		() => {
			redirectTo(config.www + 'signup?referer=' + browserHistory.location.pathname)
			props.actions.closeConfirm(CONFIRM_TYPE)
		}
	}
	actionTwo={
		() => {
			redirectTo(config.www + 'login?referer=' + browserHistory.location.pathname)
			props.actions.closeConfirm(CONFIRM_TYPE)
		}
	}
	closeAction={() => props.actions.closeConfirm(CONFIRM_TYPE)} />)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeConfirm: generalActions.closeConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(UserIsLoggedInConfirm)
